"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getRepos = void 0;
const contentTypes = require("./content-types");
const registry_call_1 = require("./registry-call");
/**
 * Fetches a list of repositories.
 *
 * OCI Distribution Specification endpoint: `/v2/_catalog`
 *
 * ## Caution
 *
 * "OCI Distribution Specification" is based on "Docker Registry HTTP API V2 Specification" but did not inherit the
 * `/v2/_catalog` endpoint.
 *
 * Most Container Registries support `/v2/_catalog` because they were implemented before OCI Distribution Specification
 * became a standard. There are no guarantees newer Container Registries will support this endpoint.
 *
 * @returns Returns a list of repositories.
 */
async function getRepos(registryBase, username, password, pageSize = 100, maxPages = Number.MAX_SAFE_INTEGER, options = {}, callChainObserver = { visitedUrls: [] }) {
    const endpoint = "/_catalog";
    const result = await (0, registry_call_1.paginatedV2Call)(registryBase, contentTypes.JSON, username, password, endpoint, "repositories", pageSize, maxPages, options, callChainObserver);
    return result;
}
exports.getRepos = getRepos;
//# sourceMappingURL=get-repos.js.map